/**
 * Verifica se Service Workers são suportados adequadamente no navegador atual.
 * Em alguns navegadores in-app (como Instagram), navigator.serviceWorker pode existir
 * mas ser undefined ou não funcional, causando erros ao tentar acessar suas propriedades.
 */
export function isServiceWorkerSupported(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  // Verifica se navigator existe
  if (!('navigator' in window)) {
    return false;
  }

  // Verifica se serviceWorker está disponível
  if (!('serviceWorker' in navigator)) {
    return false;
  }

  // Verifica se navigator.serviceWorker não é undefined
  // Em alguns navegadores in-app, 'serviceWorker' in navigator retorna true
  // mas navigator.serviceWorker é undefined
  if (navigator.serviceWorker === undefined) {
    return false;
  }

  // Verifica se o service worker tem as propriedades necessárias
  try {
    // Tenta acessar propriedades básicas do service worker
    if (typeof navigator.serviceWorker.register !== 'function') {
      return false;
    }
    if (typeof navigator.serviceWorker.getRegistrations !== 'function') {
      return false;
    }
  } catch (error) {
    // Se houver erro ao acessar, não é suportado
    return false;
  }

  return true;
}

/**
 * Verifica se é um navegador in-app conhecido que pode ter problemas com service workers
 */
export function isInAppBrowser(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const userAgent = navigator.userAgent || '';
  const inAppPatterns = [
    /Instagram/i,
    /FBAN|FBAV/i, // Facebook App
    /FB_IAB|FBIOS/i, // Facebook In-App Browser
    /Line\//i, // Line App
    /Snapchat/i,
    /TikTok/i,
    /MicroMessenger/i, // WeChat
    /Twitter/i,
    /LinkedIn/i,
    /Pinterest/i,
    /WhatsApp/i,
  ];

  return inAppPatterns.some((pattern) => pattern.test(userAgent));
}
